import ShowTours from "../../components/ShowTours/ShowTours";
import { RoutePattern } from "../../routes/RoutePattern";

export default function Tour() {
  return (
    <div
      id={RoutePattern.TOUR}
      className="w-full md:min-h-screen flex flex-col justify-center items-center pb-[100px] md:pb-0"
    >
      <h2 className="section-heading">TOUR</h2>
      <div className="mt-[--space-btw-sections] w-5/6 md:w-1/2">
        <ShowTours />
      </div>
    </div>
  );
}
